import React from 'react'

import { ReactComponent as DragableDots } from '../../../../../../../../assets/icons/draggable-dots.svg'
import { tableColumnsSize } from '../../const/tableColumnsSize'

const ReorderCol = {
  Cell: rowData => {
    return (
      // Do not show drag button until product is selected
      <div style={{ opacity: rowData.data ? 1 : 0 }}>
        <DragableDots />
      </div>
    )
  },
  style: { maxWidth: tableColumnsSize.dragBtn, padding: 0 }
}

export default ReorderCol
